<style>
@import '../views/Contact.css';
</style>

<template>
  <section class="contato">
    <div class="contato bg-white-1 p-100">
      <div class="container">
        <div class="row">
          <div class="col-12 mb-4 text-center">
            <h1 class="h1-after-center text-uppercase fwb mb-4">Contato</h1>
            <div class="box-desc text-center">
              <p class="inter-n">
                Estamos sempre prontos para atendê-los em caso de dúvidas e
                informações. Basta preencher o formulário abaixo, retornaremos o
                contato o mais breve possível.
              </p>
            </div>
          </div>
          <div class="col-md-6 mb-md-0 mb-5 inter-b">
            <div class="cont-form form-custom">
              <div class="form-group">
                <label for="inputNome">Nome Completo</label>
                <input
                  type="text"
                  class="form-control"
                  id="inputNome"
                  aria-describedby="nome"
                  v-model="contact.name"
                />
              </div>
              <div class="form-group">
                <label for="inputEmail">E-mail</label>
                <input
                  type="email"
                  class="form-control"
                  id="inputEmail"
                  placeholder="seuemail@dominio.com"
                  v-model="contact.email"
                />
              </div>
              <div class="form-group">
                <label for="inputCelular">Celular</label>
                <input
                  type="tel"
                  class="form-control"
                  id="inputCelular"
                  placeholder="(XX) XXXXX-XXXX"
                  v-mask="['(##) #####-####', '(##) ####-####']"
                  v-model="contact.phoneNumber"
                />
              </div>
              <div class="form-group">
                <label for="inputTelefone">Telefone (opcional)</label>
                <input
                  type="tel"
                  class="form-control"
                  id="inputTelefone"
                  placeholder="(XX) XXXX-XXXX"
                  v-mask="'(##) ####-####'"
                  v-model="contact.telephone"
                />
              </div>
              <div class="form-group">
                <label for="inputEmail">Assunto</label>
                <input
                  type="text"
                  class="form-control"
                  id="inputAssunto"
                  v-model="contact.subject"
                />
              </div>
              <div class="form-group">
                <label for="textarea1">Mensagem</label>
                <textarea
                  class="form-control"
                  id="textarea1"
                  rows="3"
                  v-model="contact.message"
                  placeholder="Digite sua mensagem com no mínino 10 caracteres e no máximo 1000 carecteres"
                ></textarea>
              </div>
              <div class="d-flex justify-content-center">
                <button
                  type="submit"
                  class="btn-custom text-uppercase"
                  @click="sendContact()"
                >
                  Enviar
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div>
              <!--Icon for share in the social media-->
              <!-- <div class="box-info bg-white">
                <div class="item mb-2">
                  <i class="fab fa-whatsapp c-orange"></i>
                  <a class="c-black font-weight-bold" href="tel:+5519992065613">
                    <small>+55 19</small> 9 9206-5613
                  </a>
                </div>
                <div class="mb-2">
                  <a
                    class="c-black font-weight-bold c-orange-hover no-text-decoration fs-14"
                    href="mailto:contato@construp.com.br"
                  >
                    <i class="fas fa-envelope mr-1 fs-18"></i>
                    contato@construp.com.br
                  </a>
                </div>
                <div class="item mt-2">
                  <a
                    class="mr-2 c-orange"
                    href="https://www.facebook.com/ConstruaJaBR/?ref=bookmarks"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i class="fab fa-facebook-square"></i>
                  </a>
                  <a
                    class="mr-2 c-orange"
                    href="https://www.instagram.com/construajabr/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i class="fab fa-instagram"></i>
                  </a>
                  <a
                    class="c-orange"
                    href="https://www.youtube.com/channel/UCZeTogAHNOFIWGkxHoceVNg"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i class="fab fa-youtube"></i>
                  </a>
                </div>
              </div> -->
              <iframe src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d58732.31451708208!2d-47.03078642095056!3d-23.068904890633736!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x94cf3271d569d331%3A0xcc096cbbfa515c01!2sBelenus%20-%20F%C3%A1brica%20-%20Rua%20Joana%20Foresto%20Storani%20-%20Distrito%20Industrial%2C%20Vinhedo%20-%20SP!3m2!1d-23.068989199999997!2d-46.989586599999996!5e0!3m2!1spt-BR!2sbr!4v1694022426033!5m2!1spt-BR!2sbr"
              width="100%"
              height="540"
              frameborder="0"
              style="border: 20"
              allowfullscreen
              class="style-map"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
//Programantion using Javascritp
import scrollToElement from '../mixins/scrollToElement';

export default {
 mixins:[scrollToElement],
  name: "contato",

  //Variables
  data() {
    return {
      contact: {
        name: null,
        email: null,
        phoneNumber: null,
        telephone: null,
        subject: null,
        message: null,
      },
    };
  },
  
  computed: {
    // isContactPage() {
    //   return (this.$route.name === 'contato');
    // },
  },
  created(){
    this.scrollToElement();
  },
  mounted() {
   this.scrollToElement();
 
  //   if (this.isContactPage) {
  //     this.addMauticScript();
  //   }
  // },
  // beforeDestroy() {
  //   this.destroyMauticScript();
  },

  methods: {
    addMauticScript() {
      const tagElement = document.createElement('script');
      tagElement.setAttribute('src', '//mautic.construaja.com.br/focus/1.js');
      tagElement.async = true;
      tagElement.setAttribute('charset', 'utf-8');
      tagElement.setAttribute('type', 'text/javascript');
      tagElement.setAttribute('id', 'mauticContact');
      document.body.appendChild(tagElement);
    },
    notificationPopup(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    sendContact() {
      const self = this;
      if (!this.$validate.name(this.contact.name)) {
        this.notificationPopup('Por favor, digite um nome válido!', 'warning');
      } else if (!this.$validate.email(this.contact.email)) {
        this.notificationPopup('Por favor, digite um email válido!', 'warning');
      } else if (!this.$validate.telephone(this.contact.phoneNumber)) {
        this.notificationPopup(
          'Por favor, digite um celular válido!',
          'warning'
        );
      } else if (
        this.contact.subject === null ||
        this.contact.subject.length <= 4 ||
        this.contact.subject.length >= 60
      ) {
        this.notificationPopup(
          'Por favor, digite um assunto válido!',
          'warning'
        );
      } else if (
        this.contact.message === null ||
        this.contact.message.length <= 10 ||
        this.contact.message.length >= 1000
      ) {
        this.notificationPopup(
          'Por favor, escreva uma mensagem válida!',
          'warning'
        );
      } else {
        this.$store.dispatch('startLoader');
        this.$store
          .dispatch('sendContactEmail', this.contact)
          .then(() => {
            this.contact.name = '';
            this.contact.email = '';
            this.contact.phoneNumber = '';
            this.contact.telephone = '';
            this.contact.subject = '';
            this.contact.message = '';
            setTimeout(() => {
              self.$store.dispatch('endLoader');
              self.notificationPopup(
                'Obrigado pelo seu contato, em breve responderemos!',
                'success'
              );
            }, 1000);
          })
          .catch(() => {
            this.$store.dispatch('endLoader');
          });
      }
    },
    destroyMauticScript() {
      const mauticScript = document.getElementById('mauticContact');
      if (mauticScript) {
        document.body.removeChild(mauticScript);
      }
    },
  },
};
</script>
